<template>
  <div class="form-generator">
    <FormGenerator :data="form" :isLoading="isLoading" :extra-item="mockItemProject" :extra-options="extraOptions" @submit="submit" />
  </div>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import { mapGetters } from 'vuex'

export default {
  name: 'FinancesCompensationsForm',
  data () {
    return {
      form: {
        started_at: {
          type: 'datepicker',
          name: 'started_at',
          label: 'Started at*',
          format: 'MM/dd/yyyy',
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-md-2'
        },
        user: {
          type: 'select',
          name: 'user_id',
          label: 'Specialist',
          placeholder: 'Specialist',
          valueField: 'id',
          selectLabel: 'label',
          options: [],
          value: null,
          validation: [{ name: 'required' }],
          disabled: this.edit,
          class: 'col-md-10'
        },
        value: {
          type: 'input',
          name: 'value',
          label: 'Default project value*',
          placeholder: 'Value',
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-md-4'
        },
        currency: {
          type: 'select',
          name: 'currency',
          label: 'Currency',
          placeholder: 'Currency',
          valueField: 'code',
          selectLabel: 'code',
          options: [],
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-md-4'
        },
        compensation_type: {
          type: 'select',
          name: 'compensation_type',
          label: 'Compensation type*',
          placeholder: 'Select compensation type',
          valueField: 'type',
          selectLabel: 'label',
          options: [
            {
              type: 'monthly',
              label: 'Monthly'
            },
            {
              type: 'hourly_rate',
              label: 'Hourly rate'
            }
          ],
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-md-4'
        },
        kpi_bonus: {
          type: 'input',
          name: 'kpi_bonus',
          label: 'KPI bonus',
          placeholder: 'no bonus',
          value: null,
          class: 'col-md-6'
        },
        tax_type: {
          type: 'select',
          name: 'tax_type',
          label: 'Tax type*',
          placeholder: 'Select tax type',
          valueField: 'id',
          selectLabel: 'tax_type_name',
          options: [],
          value: 0,
          validation: [{ name: 'required' }],
          class: 'col-md-6'
        }
      },
      extraOptions: {
        addBtn: 'projects',
        triggerField: 'compensation_type',
        triggerValue: 'hourly_rate',
        keySubmit: 'projects'
      },
      mockItemProject: {
        project: {
          type: 'select',
          name: 'projects',
          label: 'Select project',
          valueField: 'name',
          selectLabel: 'name',
          options: this.getProjects,
          value: null,
          class: 'col-5'
        },
        value: {
          type: 'input',
          name: 'value',
          label: 'Value*',
          placeholder: 'Value',
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-5'
        }
      }
    }
  },
  props: {
    allUsers: {
      type: Array
    },
    currencies: {
      type: Array
    },
    taxTypes: {
      type: Array
    },
    edit: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String
    },
    dataProps: {
      type: Object,
      default: () => {}
    },
    modal: {
      type: Boolean
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    showPreloader: {
      type: Boolean,
      default: () => false
    }
  },
  components: {
    FormGenerator
  },
  mounted () {
    this.setInitialData()
  },
  watch: {
    currencies: function () {
      this.form.currency.options = this.currencies
    }
  },
  computed: {
    ...mapGetters({
      dateFormat: 'dateFormat',
      getProjects: 'projects/getProjects'
    })
  },
  methods: {
    setInitialData () {
      this.form.user.options = this.allUsers
      this.form.currency.options = this.currencies
      this.form.tax_type.options = [{
        comment: '',
        formula: '',
        id: 0,
        started_at: '',
        tax_type_name: 'No Tax',
        updated_at: ''
      }, ...this.taxTypes]

      this.form.started_at.value = this.dataProps.started_at
        ? this._toLocalTime(this.dataProps.started_at)
        : this._localNowTime()
      this.form.value.value = this.dataProps.value
      this.form.user.value = this.dataProps.user ? this.dataProps.user : null
      const compensationType = this.dataProps.compensation_type !== null ? this.dataProps.compensation_type : 1
      this.form.compensation_type.value = this.form.compensation_type.options[compensationType]
      this.form.tax_type.value = this.dataProps.tax_type ? this.dataProps.tax_type : this.form.tax_type.options[0]
      this.form.kpi_bonus.value = this.dataProps.kpi_bonus
      this.mockItemProject.project.options = this.getProjects
      this.form.currency.value = this.dataProps.currency
        ? this.dataProps.currency
        : this.currencies.find(currency => currency.code === 'USD')

      this.form.projects = this.dataProps.projects
        ? this.dataProps.projects.map(project => {
          return {
            project: project.project_id,
            value: project.value
          }
        })
        : []
    },
    submit (data) {
      const sendData = {}

      sendData['user_id'] = data.user.value.id
      sendData['currency'] = data.currency.value.code
      sendData['value'] = data.value.value
      sendData['started_at'] = this._toLocalTime(data.started_at.value)
      const compensationType = data.compensation_type
      sendData['compensation_type'] = compensationType.value[compensationType.valueField]
      const taxType = data.tax_type
      sendData['tax_type'] = taxType.value[taxType.valueField]
      sendData['kpi_bonus'] = data.kpi_bonus.value

      if (compensationType.value[compensationType.valueField] === 'hourly_rate') {
        sendData['projects'] = []

        if (typeof data.projects !== 'undefined' && Array.isArray(data.projects) && data.projects.length > 0) {
          data.projects.forEach((item) => {
            sendData['projects'].push({ project: item.project.value.id, value: item.value.value })
          })
        }
      }

      this.$emit('submit', sendData)
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-form {
  position: relative;
  padding: 20px 30px;
}
.preloader {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
}
</style>
